import type { ReactNode } from 'react';

export function HolterContainer(props: { children: ReactNode; inModal?: boolean }) {
    return (
        <div className={props.inModal ? 'recorders in-modal' : 'recorders'}>
            <div className="row">{props.children}</div>
        </div>
    );
}
